import React from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, Row, Col } from '@sm/wds-react';
import ProductCalloutItem from '~app/components/ProductCalloutItem';

import './products-callout-list.scss';

const ProductsCalloutList = ({ calloutItem1, calloutItem2, utSource, hideCTAs }) => {
  return (
    <Container data-testid="ProductsCalloutList">
      <Grid fluid noGutters noBleeds>
        <Row>
          <Col
            lg={6}
            xs={12}
            className={`
              sm-products-callout-list__background--${calloutItem1.ctaColor}`}
          >
            <Choose>
              <When condition={hideCTAs}>
                <ProductCalloutItem
                  className="sm-product-callout-item__left"
                  {...calloutItem1}
                  utSource={utSource}
                  hideCTAs
                />
              </When>
              <Otherwise>
                <ProductCalloutItem className="sm-product-callout-item__left" {...calloutItem1} utSource={utSource} />
              </Otherwise>
            </Choose>
          </Col>
          <Col
            lg={6}
            xs={12}
            className={`
              sm-products-callout-list__background--${calloutItem2.ctaColor}`}
          >
            <Choose>
              <When condition={hideCTAs}>
                <ProductCalloutItem {...calloutItem2} utSource={utSource} hideCTAs />
              </When>
              <Otherwise>
                <ProductCalloutItem {...calloutItem2} utSource={utSource} />
              </Otherwise>
            </Choose>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

ProductsCalloutList.propTypes = {
  calloutItem1: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    ctaColor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  calloutItem2: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    ctaColor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  utSource: PropTypes.string.isRequired,
  hideCTAs: PropTypes.bool,
};

ProductsCalloutList.defaultProps = {
  hideCTAs: false,
};

export default ProductsCalloutList;
